import React from 'react'
import { Icon } from '@iconify/react'

const ContactUs = () => {

  return (
    <div className="min-h-screen pt-20">
      <div className="max-w-[1440px] mx-auto px-4 py-12">
        {/* Başlık Bölümü */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-[#2E3192] mb-4">İletişim</h1>
          <p className="bg-white text-lg text-gray-600 max-w-2xl mx-auto shadow-md rounded-lg p-8">
            20 yılı aşkın deneyimimizle size en iyi hizmeti sunmak için buradayız. 
            Sorularınız için bizimle iletişime geçin.
          </p>
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          {/* İletişim Bilgileri ve Adres */}
          <div className="grid md:grid-cols-2 gap-8 relative z-20">
            {/* İletişim Kartları */}
            <div className="bg-white rounded-lg shadow-lg p-6 relative z-30">
              <h3 className="text-xl font-semibold text-[#2E3192] mb-6">İletişim Bilgileri</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="bg-[#CCDC59]/10 p-3 rounded-lg">
                    <Icon icon="logos:whatsapp-icon" className="w-6 h-6 text-[#2E3192]" />
                  </div>
                  <div>
                    <p className="font-medium text-[#2E3192]">WhatsApp</p>
                    <p className="text-gray-600">+90 541 396 7820 / +90 501 032 5260</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="bg-[#CCDC59]/10 p-3 rounded-lg">
                    <Icon icon="logos:telegram" className="w-6 h-6 text-[#2E3192]" />
                  </div>
                  <div>
                    <p className="font-medium text-[#2E3192]">Telegram</p>
                    <p className="text-gray-600">+90 501 032 5260 / +90 541 396 7820</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="bg-[#CCDC59]/10 p-3 rounded-lg">
                    <Icon icon="mdi:email" className="w-6 h-6 text-[#2E3192]" />
                  </div>
                  <div>
                    <p className="font-medium text-[#2E3192]">E-posta</p>
                    {/* <p className="text-gray-600">info@gainservo.com</p> */}
                    <p className="text-gray-600">info@gainservo.com</p>
                    <p className="text-gray-600">orhan.kaluc@gainservo.com</p>
                    <p className="text-gray-600">orkun.sahin@gainservo.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Adres Bilgisi */}
            <div className="bg-white rounded-lg shadow-lg p-6 relative z-30">
              <h3 className="text-xl font-semibold text-[#2E3192] mb-4">Adresimiz</h3>
              <div className="flex items-start gap-3">
                <div className="bg-[#CCDC59]/10 p-3 rounded-lg">
                  <Icon icon="mdi:map-marker" className="w-6 h-6 text-[#2E3192]" />
                </div>
                <div>
                  <p className="text-gray-600 leading-relaxed">
                    Oruç Reis Mahallesi<br />
                    Tekstilkent İş Merkezi A8 Blok No:42<br />
                    İstanbul
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Harita Bölümü */}
        <div className="mt-16 relative z-10">
          <h2 className="text-2xl font-semibold text-[#2E3192] mb-6 text-center">Konumumuz</h2>
          <div className="bg-white rounded-lg shadow-lg overflow-hidden relative z-20">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d752.0298150164898!2d28.8650833!3d41.0663857!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab00137bc7a7d%3A0x56ccbec3254dc381!2sOru%C3%A7reis%2C%20Tekstilkent%20A8%20Blok%2C%2034235%20Esenler%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1760215387196!5m2!1str!2str"
              width="100%" 
              height="400" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Gainservo Konumu"
              className="w-full"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactUs
